import { render, staticRenderFns } from "./sustain.vue?vue&type=template&id=2b07169d"
import script from "./sustain.vue?vue&type=script&lang=js"
export * from "./sustain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports